module.exports = __webpack_public_path__ + "img/Move.8aff7000.svg";